import { render, staticRenderFns } from "./auditFailed.vue?vue&type=template&id=97a452d4&scoped=true"
import script from "./auditFailed.vue?vue&type=script&lang=js"
export * from "./auditFailed.vue?vue&type=script&lang=js"
import style0 from "./auditFailed.vue?vue&type=style&index=0&id=97a452d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a452d4",
  null
  
)

export default component.exports